module.exports = __webpack_public_path__ + "img/sixpackcarrier43.0cc0b2d2.jpg";